import { ApiServiceBase } from '../api-service-base';
import { dataFieldsService } from '../data-fields/data-fields.service';
import { IInspirationGalleryCatalogPreviewProduct, TourAndGallerySettings } from './types';

export class TourAndGalleryService extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl(shopId: number): string {
    return `${this.serviceBaseUri}/${shopId}/camera/inspiration-gallery`;
  }

  async get(shopId: number): Promise<TourAndGallerySettings> {
    const url = this.getUrl(shopId);
    const response = await this.httpService.get({ url });
    return response.data;
  }

  async update(shopId: number, settings: TourAndGallerySettings): Promise<TourAndGallerySettings> {
    const url = this.getUrl(shopId);
    const response = await this.httpService.put({ url, data: settings });
    return response.data;
  }

  async getCatalogPreview(shopId: number): Promise<IInspirationGalleryCatalogPreviewProduct[]> {
    const url = `${this.getUrl(shopId)}/catalog-preview`;
    const response = await this.httpService.get({ url });
    return response.data?.products ?? [];
  }

  async checkSku(
    shopId: number,
    sku: string,
    cancellationSignal?: AbortSignal
  ): Promise<{ exists: boolean; ctlImageUrl?: string }> {
    const result = await dataFieldsService.getFeedProducts({
      shopId,
      searchTerms: [sku],
      primaryDataField: 'sku',
      limit: 1,
      fieldsToReturn: ['ctl_image.url'],
      cancellationSignal,
    });

    const product = result?.products?.find(p => p.sku === sku);
    return {
      exists: !!product,
      ctlImageUrl: (product?.['ctl_image.url'] as string) || undefined,
    };
  }
}

export const tourAndGalleryService = new TourAndGalleryService();
